import { Badge, Box, Container, HStack, Heading, Icon, List, Text, VStack } from '@chakra-ui/react';
import { FiCheckCircle } from 'react-icons/fi'
import { MODULES, ModuleId } from '../modules/registry'

export function ModuleComingSoonPage({ moduleId }: { moduleId: ModuleId }) {
  const mod = MODULES.find((m) => m.id === moduleId)
  if (!mod) return null

  return (
    <Container maxW="container.md" py={12}>
      <VStack gap={4} align="flex-start">
        <HStack gap={3}>
          <Icon boxSize={8} color="accent" asChild><mod.icon /></Icon>
          <Heading size="lg">{mod.label}</Heading>
          <Badge colorPalette="purple">Coming Soon</Badge>
        </HStack>
        <Text color="gray.600">{mod.description}</Text>
        {!!mod.plannedFeatures?.length && (
          <Box bg="surface" p={6} borderRadius="lg" shadow="md" w="100%">
            <Heading size="sm" mb={3}>
              Planned features
            </Heading>
            <List.Root gap={2}>
              {mod.plannedFeatures.map((feature) => (
                <List.Item key={feature} fontSize="sm" color="gray.700">
                  <List.Indicator color="accent" asChild><FiCheckCircle /></List.Indicator>
                  {feature}
                </List.Item>
              ))}
            </List.Root>
          </Box>
        )}
      </VStack>
    </Container>
  );
}
